import React from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

import './FoodAlert.css'

const FoodAlert = () => {
  const { t } = useTranslation()

  if (process.env.REACT_APP_SHOW_FOOD_ALERT !== 'true') return null

  const hasMessage = t('foodstuff_message') !== 'foodstuff_message'

  document.body.style.marginTop = '130px'

  return createPortal(
    <div className="food-alert">
      <div className="food-alert__content">
        <p className="food-alert__title">{t('foodstuff_title')}</p>
        {hasMessage && (
          <p className="food-alert__message">{t('foodstuff_message')}</p>
        )}
      </div>
    </div>,
    document.getElementById('foodstuff'),
  )
}

export { FoodAlert }
